export { default } from './MerchRecommendationsCarousel';
